import dynamic from 'next/dynamic';
import type { ComponentType, ReactNode } from 'react';

import { isOnPrem } from '../shared/build-profile';

export interface MergeConnectButtonProps {
  /** Required by Merge Link token API — which connector to authenticate. */
  connector: string;
  /** Shorter “Connect” label for table rows (default: “Connect {app}”). */
  compact?: boolean;
  /** Fired after Merge Link succeeds (in-chat connect chips). */
  onConnected?: () => void;
  /** Fired when Link token creation or the Link SDK errors. */
  onFailed?: () => void;
  onBusyChange?: (busy: boolean) => void;
  disabled?: boolean;
  /** Replaces the default Connect copy. */
  children?: ReactNode;
}

/**
 * The Merge SDK phones home to ah-cdn.merge.dev. The factory stays at module
 * scope; on-prem renders nothing. The installer patch replaces this module
 * with a stub, because the bundler does not drop the factory on its own.
 */
const MergeConnectButtonImpl: ComponentType<MergeConnectButtonProps> = dynamic(
  () => import('./merge-connect-button-impl').then((m) => m.MergeConnectButtonImpl),
  { ssr: false }
);

export function MergeConnectButton(props: MergeConnectButtonProps) {
  if (isOnPrem()) return null;
  return <MergeConnectButtonImpl {...props} />;
}
